var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{
      name: 'PatientRecordProgressStatusJourney',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("buttons.journey", {catalog: 'app_mobile'})))+" ")]),_c('v-tab',{attrs:{"to":{
      name: 'PatientRecordProgressStatusParameters',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("journeyProgress.parameters")))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }